<template>
  <div>
    <article>
      <table width="100%" border="2">
        <tr>
          <td>
            <h2 class="text-center">#{{order.id}}</h2>
          </td>
        </tr>
        <tr>
          <td>
            <p><b-img :src="$store.state.store.logo" height="50%" /></p>
            <p>{{$store.state.store.name}}</p>
            <p>{{$store.state.store.mobile_contact}}</p>
            <p>{{$store.state.store.email_contact}}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p><b class="mt-1">بيانات العميل:</b></p>
            <p>{{order.username}}</p>
            <p>{{order.mobile}}</p>
            <p>{{order.email}}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p><b>عنوان الشحن:</b></p>
            <p>{{order.address_owner}}</p>
            <p>{{order.city.name}}</p>
            <p>{{order.address_details}}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>{{order.notes}}</p>
          </td>
        </tr>
      </table>
    </article>
  </div>
</template>

<script>
import useJwt from '@/auth/useJwt'

export default {
  data() {
    return {
      isLoading: false,
      order: {}
    }
  },
  computed: {
    
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    getOrder(){
      this.isLoading = true
      useJwt.post('/orders/get-by-id',{id: this.$route.params.id})
      .then((response) => {
        // console.log(response.data.data)
        this.order = response.data.data
        this.isLoading = false
      })
      .catch(response => {
        this.isLoading = false
        // console.log(response);
      });
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
@media print
{
  @page
  {
    // size: A5 portrait; 
    // margin: 0;
    // height: 5in;
    // width: 4in;
    size: portrait;
    margin: 0;
  }
  html
  {
    // width: 100%;
    // height: 100%;
    height: 5in;
    width: 4in;
    box-sizing: border-box;
  }
  *, *:before, *:after
  {
    box-sizing: inherit;
  }
  body {
    /* A5 dimensions */
    // height: 5in;
    // width: 4in;

    margin: 0;
  }
  article
  {
    width: 4in;
    height: 5in;
    padding: 0.05in;
  }
  table {
    // width: 4in;
  }
  td {
    padding: 0.05in;
  }
  h2, p {
    margin: 0;
  }
}
</style>
